import ListContent from './ListContent';

export default ListContent;
